export const REFRESH_USER_COUNT = "REFRESH_USER_COUNT";

import { get, put, post, destroy } from "utils/fetchRequest";

export const getDeliveryList = async (
  searchText,
  type,
  authorId,
  page,
  pageLimit,
  userRole,
  branch
) => {
  try {
    const result = await get(
      `delivery?1=1${searchText ? `&search=${searchText}` : ""}${page ? `&page=${page}` : ""}${pageLimit ? `&limit=${pageLimit}` : ""}${type ? `&type=${type}` : ""}${userRole ? `&id=${userRole}` : ""}${branch ? `&branchIdUser=${branch}` : ""}`
    );

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const createDelivery = async (data) => {
  try {
    const result = await post("delivery", data);

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const updateDelivery = async (id, data) => {
  try {
    const result = await put(`delivery/${id}`, data);

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const deleteDelivery = async (id) => {
  try {
    const result = await destroy(`delivery/${id}`);

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const setSpecial = async (id, data) => {
  try {
    const result = await put(`delivery/special/${id}`, data);

    return result;
  } catch (err) {
    return { error: err };
  }
};
